"use client"

import type React from "react"

interface ErrorViewProps {
  title?: string
  description?: string
  onRetry?: () => void
  onStartOver?: () => void
}

const ErrorView: React.FC<ErrorViewProps> = ({
  title = "Configuration Not Found",
  description = "Unable to load your sync configuration. Please start over.",
  onRetry,
  onStartOver,
}) => (
  <div className="review-sync-setup">
    <div className="error-container">
      <div className="error-icon">⚠️</div>
      <h2>{title}</h2>
      <p>{description}</p>
      <div className="error-actions">
        {onRetry && (
          <button onClick={onRetry} className="retry-button">
            Try Again
          </button>
        )}
        {onStartOver && (
          <button onClick={onStartOver} className="start-over-button">
            Start Over
          </button>
        )}
      </div>
    </div>
  </div>
)

export default ErrorView
